import React from "react";
import { DataGrid, GridColDef, GridValueGetterParams } from "@mui/x-data-grid";
import {
  Box,
  FormControl,
  InputLabel,
  Link,
  MenuItem,
  Modal,
  TextField,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";
import { Button } from "@material-ui/core";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import Grid from "@mui/material/Unstable_Grid2";
import SelectDropdown from "../../../../../Supporting files/SelectDropdown/SelectDropdown";
import SlidingPanel from "react-sliding-side-panel";
import UGTable from "../../../../../Supporting files/UGTable/UGTable";
interface Props {
  attrName: any;
  open_status: boolean;
  value_update: Function;
}

const Department: React.FC<Props> = ({
  open_status,
  attrName,
  value_update,
}) => {
  const [addNewDepartment, setAddNewDepartment] = React.useState(false);
  const [departmentName, setDepartmentName] = React.useState("");
  const [reportingManager, setReportingManager] = React.useState("");
  const [employeeList, setEmployeeList] = React.useState("");
  const [pageStatus, setPageStatus] = React.useState<number>(1);

  //Table Data
  const [columns, setColumns] = React.useState([
    {
      field: "id",
      headerName: "Id",
      width: 70,
      check_status: true,
    },
    {
      field: "departmentName",
      headerName: "Department Name",
      width: 230,
      check_status: true,
    },
    {
      field: "reportingManager",
      headerName: "Reporting Manager",
      width: 200,
      check_status: true,
    },
    {
      field: "numberOfEmployees",
      headerName: "Number of Employees",
      width: 200,
      check_status: true,
    },
    {
      field: "status",
      headerName: "Status",
      width: 120,
      check_status: true,
      renderCell: (data: any) => {
        const { row } = data;
        return <span className={row.status}>{row.status}</span>;
      },
    },
  ]);
  const rows = [
    {
      id: 1002,
      departmentName: "App Developer",
      reportingManager: "Umesh Gemini",
      numberOfEmployees: "10",
      status: "Pending",
    },
    {
      id: 1003,
      departmentName: "App Developer",
      reportingManager: "Umesh Gemini",
      numberOfEmployees: "10",
      status: "Active",
    },
    {
      id: 1004,
      departmentName: "App Developer",
      reportingManager: "Umesh Gemini",
      numberOfEmployees: "10",
      status: "Inprogress",
    },
    {
      id: 1005,
      departmentName: "App Developer",
      reportingManager: "Umesh Gemini",
      numberOfEmployees: "10",
      status: "Rejected",
    },
    {
      id: 1006,
      departmentName: "App Developer",
      reportingManager: "Umesh Gemini",
      numberOfEmployees: "10",
      status: "Active",
    },
    {
      id: 1007,
      departmentName: "App Developer",
      reportingManager: "Umesh Gemini",
      numberOfEmployees: "10",
      status: "Rejected",
    },
    {
      id: 1008,
      departmentName: "App Developer",
      reportingManager: "Umesh Gemini",
      numberOfEmployees: "10",
      status: "Pending",
    },
    {
      id: 1009,
      departmentName: "App Developer",
      reportingManager: "Umesh Gemini",
      numberOfEmployees: "10",
      status: "Active",
    },
  ];
  const departmentName_data = [
    { key: "Enggineering", value: "Enggineering" },
    { key: "Development", value: "Development" },
    { key: "Designing", value: "Designing" },
    { key: "Architecture", value: "Architecture" },
  ];
  const reportingManagers_data = [
    { key: "Umesh Gemini", value: "Umesh Gemini" },
    { key: "Rahul Raghuvanshi", value: "Rahul Raghuvanshi" },
    { key: "Uday Kumar", value: "Uday Kumar" },
    { key: "Ankit Sachdeva", value: "Ankit Sachdeva" },
  ];
  const employeeList_data = [
    { key: "Umesh Gemini", value: "Umesh Gemini" },
    { key: "Rahul Raghuvanshi", value: "Rahul Raghuvanshi" },
    { key: "Uday Kumar", value: "Uday Kumar" },
    { key: "Mobin Mirza", value: "Mobin Mirza" },
    { key: "Ankit Sachdeva", value: "Ankit Sachdeva" },
  ];
  const updateMasterState = (
    attrName: any,
    value: string | boolean | number
  ) => {
    attrName(value);
  };
  const handleChange = (event: SelectChangeEvent, attrName: string) => {
    if (attrName === "departmentName") {
      setDepartmentName(event.target.value as string);
    } else if (attrName === "reportingManager") {
      setReportingManager(event.target.value as string);
    } else if (attrName === "employeeList") {
      setEmployeeList(event.target.value as string);
    }
  };
  const changePageStatus = (status: boolean) => {
    if (status === true) {
      if (pageStatus < 2) {
        setPageStatus(pageStatus + 1);
      }
    } else {
      if (pageStatus > 1) {
        setPageStatus(pageStatus - 1);
      }
    }
  };

  return (
    <Grid container spacing={2}>
      <Grid xs={6}>
        <h3 className="mb-0">Departments</h3>
      </Grid>
      <Grid xs={6} className="text-right">
        <Link
          underline="none"
          className="blueBtn addfile"
          onClick={() => {
            setAddNewDepartment(true);
          }}
        >
          Add new department
        </Link>

        {/* <Modal
          open={addNewDepartment}
          onClick={() => {
            setAddNewDepartment(false);
          }}
          className="modalWrapper">
          <Box className="modalInner lg-width">
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Link  className="close-button"></Link>
                <h5 className="popup-heading">Add New Department</h5>
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <SelectDropdown
                 class_name="inputField"
                  title="Department Name"
                  value={departmentName}
                  attrName={setDepartmentName}
                  value_update={updateMasterState}
                  dropdown_data={departmentName_data}
                  warn_status={false}
                />
              </Grid>
              <Grid item xs={6}>
                <SelectDropdown
                 class_name="inputField"
                  title="Reporting Manager"
                  value={reportingManager}
                  attrName={setReportingManager}
                  value_update={updateMasterState}
                  dropdown_data={reportingManagers_data}
                  warn_status={false}
                />
              </Grid>
              <Grid item xs={12}>
                <SelectDropdown
                 class_name="inputField"
                  title="Employee List"
                  value={employeeList}
                  attrName={setEmployeeList}
                  value_update={updateMasterState}
                  dropdown_data={employeeList_data}
                  warn_status={false}
                />
              </Grid>
              <Grid
                item
                xs={12}
                className="ctaBtn"
                style={{ textAlign: "center" }}>
                <Button variant="contained" className="submitBtn">
                  Submit
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Modal> */}

        <SlidingPanel
          type={"right"}
          isOpen={addNewDepartment}
          size={75}
          panelClassName="slidingPanel"
          backdropClicked={() => setAddNewDepartment(false)}
        >
          <Box
            className={open_status == true ? "modalInner show" : "modalInner"}
          >
            {pageStatus == 2 ? null : (
              <Grid container spacing={3} alignItems="center">
                <Grid xs={6}>
                  <h4 className="mb-0 mt-4 text-left">Add New Department</h4>
                </Grid>

                <Grid xs={12}>
                  <hr />
                </Grid>
              </Grid>
            )}
            {pageStatus == 2 ? null : (
              <div className="scrollable_area">
                <Grid container spacing={3}>
                  <Grid xs={12}>
                    <Accordion
                      expanded={pageStatus === 1}
                      onChange={() => setPageStatus(1)}
                    >
                      <AccordionSummary aria-controls="1-content" id="1-header">
                        <Typography className="text-left ml-2">
                          Details
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Typography>
                          <Grid container spacing={2} className="mb-4">
                            <Grid xs={6}>
                              <SelectDropdown
                                class_name="inputField"
                                title="Department Name"
                                value={departmentName}
                                attrName={setDepartmentName}
                                value_update={updateMasterState}
                                dropdown_data={departmentName_data}
                                warn_status={false}
                              />
                            </Grid>
                            <Grid xs={6}>
                              <SelectDropdown
                                class_name="inputField"
                                title="Reporting Manager"
                                value={reportingManager}
                                attrName={setReportingManager}
                                value_update={updateMasterState}
                                dropdown_data={reportingManagers_data}
                                warn_status={false}
                              />
                            </Grid>
                            <Grid xs={12}>
                              <SelectDropdown
                                class_name="inputField"
                                title="Employee List"
                                value={employeeList}
                                attrName={setEmployeeList}
                                value_update={updateMasterState}
                                dropdown_data={employeeList_data}
                                warn_status={false}
                              />
                            </Grid>
                          </Grid>
                        </Typography>
                      </AccordionDetails>
                    </Accordion>
                  </Grid>
                </Grid>
              </div>
            )}
            .
            {pageStatus == 2 ? (
              <Grid container spacing={2}>
                <Grid xs={12} className="tick_animation">
                  <svg
                    className="checkmark"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 52 52"
                  >
                    <circle
                      className="checkmark__circle"
                      cx="26"
                      cy="26"
                      r="25"
                      fill="none"
                    />
                    <path
                      className="checkmark__check"
                      fill="none"
                      d="M14.1 27.2l7.1 7.2 16.7-16.8"
                    />
                  </svg>
                  <p className="quote_success">
                    New Department has been added successfully!
                  </p>
                </Grid>
              </Grid>
            ) : null}
            <Grid container spacing={2}>
              {pageStatus == 2 ? null : (
                <Grid
                  xs={12}
                  style={{ textAlign: "center", position: "relative" }}
                  className="ctaBtn"
                >
                  <Button
                    variant="contained"
                    className="submitBtn fixedbtn"
                    onClick={() => {
                      changePageStatus(true);
                    }}
                  >
                    {pageStatus == 1 ? "Submit" : "Continue"}
                  </Button>
                </Grid>
              )}
            </Grid>
          </Box>
        </SlidingPanel>
      </Grid>

      <Grid xs={12}>
        <UGTable
          header_data={columns}
          data={rows}
          value_update={updateMasterState}
          attrName={"UGTable"}
        />
      </Grid>
    </Grid>
  );
};
export default Department;
